/**
 * Skeleton do detalhe do orçamento — cabeçalho, itens e totais.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-4xl animate-pulse flex-col gap-6">
      <div className="h-4 w-28 rounded bg-slate-100" />

      {/* Cabeçalho */}
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <div className="flex items-start justify-between">
          <div className="space-y-2">
            <div className="h-5 w-52 rounded bg-slate-200" />
            <div className="h-3 w-64 rounded bg-slate-100" />
          </div>
          <div className="h-8 w-24 rounded-lg bg-slate-100" />
        </div>
        <div className="mt-4 flex gap-2 border-t border-slate-100 pt-4">
          <div className="h-8 w-40 rounded-lg bg-slate-100" />
          <div className="h-8 w-36 rounded-lg bg-slate-100" />
        </div>
      </div>

      {/* Itens */}
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <div className="mb-3 flex items-center justify-between">
          <div className="h-4 w-36 rounded bg-slate-200" />
          <div className="h-8 w-32 rounded-lg bg-slate-100" />
        </div>
        <div className="flex flex-col gap-2">
          {[0, 1, 2].map((r) => (
            <div key={r} className="flex items-center justify-between rounded-xl border border-slate-200 p-3">
              <div className="space-y-1.5">
                <div className="h-4 w-40 rounded bg-slate-200" />
                <div className="h-3 w-28 rounded bg-slate-100" />
              </div>
              <div className="flex gap-1.5">
                <div className="h-7 w-28 rounded-md bg-slate-100" />
                <div className="h-7 w-9 rounded-md bg-slate-100" />
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 space-y-1.5 border-t border-slate-100 pt-4">
          <div className="ml-auto h-3 w-40 rounded bg-slate-100" />
          <div className="ml-auto h-5 w-32 rounded bg-slate-200" />
        </div>
      </div>
    </div>
  );
}
